import React from 'react';
import { createInputStyle } from '../styles';
import { FieldProps } from '../types';

const Field = React.forwardRef<HTMLInputElement, FieldProps>(
  ({ label, type, onKeyDown }, ref) => {
    return (
      <input
        placeholder={label}
        ref={ref}
        type={type}
        onKeyDown={onKeyDown}
        style={createInputStyle('form')}
      />
    );
  },
);

Field.displayName = 'Field';

export { Field };
